import $ from 'jquery'

const TopMenu = () => {
    const deliverList = $('.deliver-list')
    const headCart = $('.head-cart')
    const headDropdown = $('.header-dropdown')
    const algoliaSection = $("#algolia-section")

    function resetHeadMenu() {
        $(document).unbind('click')
        headDropdown.removeClass('opened')
        headCart.removeClass('opened')
    }

    function showHeadMenu(login) {
        $(document).unbind('click')
        deliverList.removeClass('open')
        if(login) {
            headCart.removeClass('opened')
            headDropdown.addClass('opened')
        } else {
            headDropdown.removeClass('opened')
            headCart.addClass('opened')
        }
        algoliaSection.hide()
        setTimeout(function(){
            $(document).on('click', function (e) {
                if ($(e.target).closest('.head-cart').length === 0) {
                    headCart.removeClass('opened')
                    headDropdown.removeClass('opened')
                    $(document).unbind('click')
                }
            })
        }, 50)
    }

    $(function() {
        // Profilo
        $('.unlogged a').on('click', () => {
            showHeadMenu(true)
        });
        $('.user-menu-user .icon-close').on('click', function(e) {
            e.stopPropagation()
            setTimeout(function(){
                showHeadMenu();
            }, 10);
        });
        $("#close-panel-login, #close-pane").on('click', function(e) {
            setTimeout(function(){
                resetHeadMenu()
            }, 10);
        })
        headDropdown.on('click', function(e) {
            e.stopPropagation()
        })
        // Mega menu
        $('#hrt-man').on('mouseover', function() {
            $('.hrt-woman').css('opacity', '.5')
        }).on('mouseleave', function() {
            $('.hrt-woman').css('opacity', '1')
        })
        $('.ht-subtop').on('mouseover', function() {
            $('.cnt-content').css('opacity', '.4')
        }).on('mouseleave', function() {
            $('.cnt-content').css('opacity', '1')
        })
        // Cambio stato di spedizione
        $('#change-country, #change-country-mobile').on('click', () => {
            if ($('.deliver-list').hasClass('open')) {
                $('.deliver-list').removeClass('open')
            } else {
                $("#algolia-section").hide()
                $('.deliver-list').addClass('open')
            }
        })
        $('.deliver-close').on('click', () => {
            $('.deliver-list').removeClass('open')
        })
        $('.ht-subtop').on('mouseover', function() {
            $('.ht-subtop').removeClass('selected');
            $(this).addClass('selected');
        })
        // Footer menu
        $('.footer-mobile .collapsible-header').on('click', function() {
            if ($(this).hasClass('open')) {
                $(this).removeClass('open');
                $(this).next('.collapsible-content').removeClass('open');
            } else {
                $(this).addClass('open');
                $(this).next('.collapsible-content').addClass('open');
            }
        })
    })
}

export default TopMenu
